if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form[action*="/cart/add"]');
        this.formInput = this.form?.querySelector("[name=id]") || this.querySelector("[data-inquiry-variant-id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.deliveryVariants = JSON.parse(this.dataset.deliveryVariants || "[]");
        this.formInput?.addEventListener("change", () => this.updateDeliveryQuote());
        this.updateDeliveryQuote();
        const inquiryPanel = this.querySelector('.product-inquiry__panel');
        const openInquiry = () => {
          if (inquiryPanel && location.hash === '#ProductInquiry') inquiryPanel.open = true;
        };
        openInquiry();
        if (inquiryPanel && this.querySelector('.product-inquiry .form__success-field, .product-inquiry__errors .errors')) inquiryPanel.open = true;
        window.addEventListener('hashchange', openInquiry);
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.form?.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      updateDeliveryQuote() {
        const variant = this.deliveryVariants.find(v => String(v.id) === this.formInput?.value);
        const active = !this.hasAttribute("data-inquiry-only") && Boolean(variant?.available && variant.weight > 89811);
        const inquiryActive = this.hasAttribute("data-inquiry-only") || Boolean(variant && !variant.available);
        this.toggleAttribute("data-delivery-quote-active", active);
        this.toggleAttribute("data-inquiry-active", inquiryActive);
        const quote = this.querySelector(".delivery-quote");
        const inquiry = this.querySelector(".product-inquiry");
        if (quote) quote.hidden = !active;
        if (inquiry) inquiry.hidden = !(inquiryActive || active);
        if (!variant || (!active && !inquiryActive)) return;
        const productUrl = new URL(this.dataset.deliveryUrl, location.origin);
        productUrl.searchParams.set("variant", variant.id);
        const variantTitle = variant.title === "Default Title" ? "" : " — " + variant.title;
        const message = (inquiryActive ? "Availability inquiry: " : "Delivery quote: ") + this.dataset.deliveryProduct + variantTitle + ". Product: " + productUrl.href;
        if (inquiry) {
          const label = inquiry.querySelector('[data-inquiry-label]');
          const intro = inquiry.querySelector('[data-inquiry-intro]');
          const requestType = inquiry.querySelector('[data-inquiry-type]');
          if (label) label.textContent = active ? (inquiry.dataset.deliveryLabel || 'Request delivery quote') : (inquiry.dataset.localizedLabel || this.dataset.inquiryLabel || 'Inquire');
          if (intro) intro.textContent = active ? (inquiry.dataset.deliveryIntro || 'This size requires a delivery quote before purchasing. Include your delivery city or postal code so our team can help arrange shipping or local delivery.') : (inquiry.dataset.localizedIntro || this.dataset.inquiryIntro || 'Tell us what you have in mind. Our team can help with availability and ordering details.');
          if (requestType) requestType.value = active ? 'Delivery quote' : (this.dataset.inquiryType || 'Product availability inquiry');
          this.closest('.product__info-container')?.querySelectorAll('[data-inquiry-specs]').forEach(el => { el.hidden = el.dataset.inquirySpecs !== String(variant.id); });
          const optionField = inquiry.querySelector('[data-inquiry-variant]');
          const urlField = inquiry.querySelector('[data-inquiry-url]');
          const selection = inquiry.querySelector('[data-inquiry-selection]');
          const returnField = inquiry.querySelector('[name="return_to"]');
          if (optionField) optionField.value = variant.title;
          if (urlField) urlField.value = productUrl.href;
          if (selection) selection.textContent = this.dataset.deliveryProduct + variantTitle;
          if (returnField) returnField.value = productUrl.pathname + productUrl.search + '#ProductInquiry';
        }
        const contactUrl = new URL(this.dataset.contactUrl || "/pages/contact", location.origin);
        contactUrl.searchParams.set(inquiryActive ? "inquiry" : "delivery_quote", message);
        contactUrl.hash = "DeliveryQuoteContact";
        (inquiryActive ? inquiry : quote)?.querySelector("a")?.setAttribute("href", contactUrl.pathname + contactUrl.search + contactUrl.hash);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.updateDeliveryQuote();
        if (this.hasAttribute("data-inquiry-active")) {
          const panel = this.querySelector(".product-inquiry__panel");
          if (panel) panel.open = true;
          panel?.querySelector("summary")?.focus();
          return;
        }
        if (this.hasAttribute("data-delivery-quote-active")) {
          const panel = this.querySelector(".product-inquiry__panel");
          if (panel) panel.open = true;
          panel?.querySelector("summary")?.focus();
          return;
        }
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
        } else {
          formData.append("sections", []);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response: response },
                  bubbles: true,
                  composed: true,
                }),
              );

              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              // use handle and quickbuy closeCart()

              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        window.location = window.routes.cart_url;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
